export default "__VITE_ASSET__BA7Vae8S__"